<template>
  <b-container fluid>
    <b-modal id="birthdate-modal" title="Entrez votre date de naissance" hide-footer centered>
      <b-form @submit.prevent="onSubmitBirthdate">
        <b-form-group label="Prénom:" label-for="name-input">
          <b-form-input id="name-input" v-model="firstName" class="mb-2" placeholder="Entrez votre prénom"> </b-form-input>
        </b-form-group>

        <b-form-group label="Nom:" label-for="lastname-input">
          <b-form-input id="lastname-input" v-model="lastName" class="mb-2" placeholder="Entrez votre nom"> </b-form-input>
        </b-form-group>

        <b-form-group label="Date de naissance:" label-for="birthdate-input">
          <b-input-group class="mb-3">
            <b-form-input
              id="date-input"
              v-model="tempBirthdate"
              type="text"
              placeholder="YYYY-MM-DD"
              autocomplete="off"
            ></b-form-input>
            <b-input-group-append>
              <b-form-datepicker
                v-model="tempBirthdate"
                button-only
                right
                locale="fr-FR"
                aria-controls="date-input"
              ></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-button type="submit" @click="updateName" class="btn-left" variant="success">Soumettre</b-button>
        <b-button @click="closeModal" class="btn-right" variant="danger">Annuler</b-button>
      </b-form>
    </b-modal>
    <b-row class="text-center">
      <b-col>
        <img style="max-height: 60px; width: auto" src="@/assets/numerology/full_logo.png" />
      </b-col>
    </b-row>
    <b-row class="hero-block" :style="{ backgroundImage: `url(${backgroundImageUrl_1})` }">
      <b-col>
        <h2 class="text-center">PAR JEAN-LUC NOÉ</h2>
        <h1 class="text-center">LECTURE NUMÉROLOGIQUE OFFERTE</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="profile-block">
          <img src="@/assets/numerology/empty_profile.png" alt="profile_avatar" />
          <div class="profile-info">
            <h3>{{ name }}</h3>
            <p>
              <span v-if="gender === 'female'">Née</span>
              <span v-else>Né</span>
              le {{ day }}/{{ month }}/{{ year }}
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row class="intro-block">
          <b-col>
            <h2 class="text-center">
              LES BESOINS PROFONDS DE <span style="color: #e7b0fe; font-size: 4rem">{{ name }}</span>
            </h2>
          </b-col>
        </b-row>
        <b-row class="info-block">
          <b-col cols="2"></b-col>
          <b-col cols="3">
            <img src="@/assets/numerology/man_night_sky.png" alt="" />
          </b-col>
          <b-col cols="5">
            <p>
              Il existe 11 vibrations intimes. Chaque vibration intime peut permettre d’atteindre le “succès” au sens de la
              société, gagner suffisamment d’argent pour vivre bien. La différence est que chaque vibration a des besoins
              différents. Chaque vibration a des envies profondes fondamentalement éloignées. Certaines ont plus besoin de
              liberté, d’autres d’un cadre. Certaines ont besoin de suivre les règles, d’autres de s’en affranchir. Il n’y a pas
              de vibration intime meilleure qu’une autre. Il y a seulement votre vibration intime. Vos besoins. Vos qualités.
              C’est uniquement lorsque vous vivrez dans votre vibration intime, que vous pourrez être véritablement heureux et
              épanoui.
            </p>
          </b-col>
          <b-col cols="2"></b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="calc-block">
      <b-col>
        <h2 class="text-center">LA PREMIÈRE PARTIE DE L'ÉQUATION DE VOTRE VIE.</h2>
        <table class="lifepath-calculation-table">
          <tbody>
            <tr class="lifepath-row-1">
              <td class="lifepath-column-1">
                <div class="lifepath-block">
                  <div class="digit">{{ month }}</div>
                </div>
              </td>
              <td class="lifepath-column-2">
                <div class="lifepath-arrow"></div>
              </td>
              <td class="lifepath-column-3">
                <div class="lifepath-block">
                  <div class="digit">{{ monthDigits }}</div>
                </div>
              </td>
              <td class="lifepath-column-4">
                <div class="lifepath-arrow"></div>
              </td>
              <td class="lifepath-column-5">
                <div class="lifepath-block">
                  <span class="digit">{{ monthNumber }}</span>
                </div>
              </td>
              <td class="lifepath-column-6 empty-cell"></td>
              <td class="lifepath-column-7 empty-cell"></td>
            </tr>
            <tr class="lifepath-row-2">
              <td class="lifepath-column-1 empty-cell"></td>
              <td class="lifepath-column-2 empty-cell"></td>
              <td class="lifepath-column-3 empty-cell"></td>
              <td class="lifepath-column-4 empty-cell"></td>
              <td class="lifepath-column-5 empty-cell">
                <div class="plus">+</div>
              </td>
              <td class="lifepath-column-6 empty-cell"></td>
              <td class="lifepath-column-7 empty-cell"></td>
            </tr>
            <tr class="lifepath-row-3">
              <td class="lifepath-column-1">
                <div class="lifepath-block">
                  <div class="digit">{{ day }}</div>
                </div>
              </td>
              <td class="lifepath-column-2">
                <div class="lifepath-arrow"></div>
              </td>
              <td class="lifepath-column-3">
                <div class="lifepath-block">
                  <div class="digit">{{ dayDigits }}</div>
                </div>
              </td>
              <td class="lifepath-column-4">
                <div class="lifepath-arrow"></div>
              </td>
              <td class="lifepath-column-5">
                <div class="lifepath-block">
                  <span class="digit">{{ dayNumber }}</span>
                </div>
              </td>
              <td class="lifepath-column-6 empty-cell">
                <div class="plus">=</div>
              </td>
              <td class="lifepath-column-7 lifepath-column-result">
                <div class="lifepath-block lifepath-result">
                  <div class="digit">{{ lifePathNumber }}</div>
                </div>
              </td>
            </tr>
            <tr class="lifepath-row-4">
              <td class="lifepath-column-1 empty-cell"></td>
              <td class="lifepath-column-2 empty-cell"></td>
              <td class="lifepath-column-3 empty-cell"></td>
              <td class="lifepath-column-4 empty-cell"></td>
              <td class="lifepath-column-5 empty-cell">
                <div class="plus">+</div>
              </td>
              <td class="lifepath-column-6 empty-cell"></td>
              <td class="lifepath-column-7 empty-cell"></td>
            </tr>
            <tr class="lifepath-row-5">
              <td class="lifepath-column-1">
                <div class="lifepath-block">
                  <div class="digit">{{ year }}</div>
                </div>
              </td>
              <td class="lifepath-column-2">
                <div class="lifepath-arrow"></div>
              </td>
              <td class="lifepath-column-3">
                <div class="lifepath-block">
                  <div class="digit">{{ yearDigits }}</div>
                </div>
              </td>
              <td class="lifepath-column-4">
                <div class="lifepath-arrow"></div>
              </td>
              <td class="lifepath-column-5">
                <div class="lifepath-block">
                  <span class="digit">{{ yearNumber }}</span>
                </div>
              </td>
              <td class="lifepath-column-6 empty-cell"></td>
              <td class="lifepath-column-7 empty-cell"></td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <b-row class="number-reveal-block" :style="{ backgroundImage: `url(${backgroundImageUrl_2})` }">
      <b-col>
        <h2 class="text-center">VOTRE VIBRATION INTIME EST LE</h2>
        <h3 class="text-center">{{ lifePathNumber }}</h3>
      </b-col>
    </b-row>

    <b-row class="number-description-block">
      <b-col cols="3"></b-col>
      <b-col cols="6">
        <h2 class="text-center">VOICI CE QU'ELLE RÉVÈLE SUR VOTRE VIE</h2>

        <b-row class="py-5">
          <b-col cols="5">
            <div style="float: right">
              <img src="@/assets/numerology/mozart.png" alt="profile_avatar" />
              <p>Wolfgang Amadeus Mozart</p>
            </div>
          </b-col>
          <b-col cols="7">
            <p>
              Le 11 est la vibration de l’intuition. Vous êtes une personne puissante, ambitieuse avec une grande force de
              caractère. Votre intuition vous guide… c’est même elle qui vous emmène vers le succès. Écoutez-la et vous ne pourrez
              pas vous tromper. C’est un vrai don que vous a fait l’Univers… Alors utilisez-le ! Vous êtes une personne sensible.
              Vous ne supportez ni les limitations, ni les restrictions. Vous avez besoin de liberté, de sortir du cadre pour vous
              réaliser.
            </p>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <p style="max-width: 100%">
              Vous faites partie des atypiques, ces personnes qui sortent des sentiers battus pour construire leur propre voie,
              celle qui leur correspond vraiment. C’est notamment la vibration de Mel Gibson ou c’était celle de Mozart.
              Maintenant que vous connaissez votre vibration intime, continuons cette lecture avec votre nombre d’expression.
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3"></b-col>
    </b-row>
    <b-row class="name-calc-block" :style="{ backgroundImage: `url(${backgroundImageUrl_4})` }">
      <b-col cols="3"></b-col>
      <b-col cols="6">
        <b-row class="intro-block">
          <b-col>
            <h2 class="text-center">LE POTENTIEL DE <span style="color: #e7b0fe; font-size: 4rem">PRENOM</span></h2>
          </b-col>
        </b-row>
        <b-row class="text-center">
          <b-col>
            <div class="name-numerology">
              <div v-for="(word, i) in words" :key="i">
                <div class="letter-container" v-for="(letter, index) in word.toUpperCase().split('')" :key="index">
                  <span class="number">{{ getAlphabetNumber(letter) }}</span>
                  <div class="letter">{{ letter }}</div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              Le nombre d’expression est une valeur clé de la Numérologie. Il représente votre potentiel d’expression, de contact.
              C’est pour cette raison que je l’appelle nombre de la destinée. C’est votre potentiel, que vous êtes libre ou non
              d’accomplir.
            </p>
            <ul>
              <li>Vous êtes un humanitaire.</li>
              <li>Vous êtes une personne pleine de compassion et aux tendances idéalistes.</li>
              <li>Votre envie la plus profonde est de métamorphoser le monde.</li>
              <li>Vous êtes le plus heureux lorsque vous participez à une activité qui profite directement au bien public.</li>
              <li>Votre cœur fait de vous une personne tolérante, qui n’est pas soumise aux préjugés.</li>
              <li>Vous aimez sortir de la routine et vivre de nouvelles expériences.</li>
              <li>Votre amour fait de vous un leader qui attire les autres.</li>
            </ul>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3"></b-col>
    </b-row>
    <b-row class="white-bg py-5">
      <b-col cols="3"></b-col>
      <b-col cols="6">
        <div class="text-center py-2">
          <img style="margin: 0 auto; width: 200px" src="@/assets/numerology/icon_zoom.png" alt="" />
        </div>

        <h2>LE POUVOIR DE VOTRE ÉTUDE NUMÉROLOGIQUE SUR-MESURE</h2>
        <p>Lorsque l’on arrive à un certain stade de la vie, il est normal de se poser des questions.</p>
        <ul>
          <li>Ai-je pris les bonnes décisions pour ma famille ? Pour ma carrière ? Ai-je choisi le bon partenaire ?</li>
          <li>
            Est-ce que j’exprime vraiment tout mon potentiel au travail… Ou est-ce que j’ai l’impression de manquer de sens, de ne
            pas être à ma place…
          </li>
          <li>Ai-je passé autant d’années dans la bonne carrière ? Ai-je véritablement exprimé TOUT mon potentiel ?</li>
        </ul>
        <p>Bref…</p>
        <ul>
          <li>Est-ce que je suis à ma place ?</li>
          <li>Est-ce que j’ai même déjà ÉTÉ à ma place ?</li>
        </ul>
      </b-col>
      <b-col cols="3"></b-col>
    </b-row>
    <b-row class="empty-row" :style="{ backgroundImage: `url(${backgroundImageUrl_3})`, minHeight: '400px' }">
      <b-col></b-col>
    </b-row>
    <b-row class="white-bg py-5">
      <b-col cols="3"></b-col>
      <b-col cols="6">
        <b-row>
          <b-col>
            <p>
              Si vous avez déjà eu cette impression, c’est normal. Vous avez pu le remarquer avec votre début de lecture
              Numérologique, décoder votre date de naissance est bien plus efficace que se poser des questions… On peut passer des
              années à se poser les mêmes questions, à méditer sur une seule et même pensée, à s’oublier dans une carrière qui
              semble être la bonne… sans jamais trouver la solution. La direction de votre vie est déjà déterminée avant même
              votre naissance. Aussi forte que soit votre volonté, si vous vous acharnez dans la direction qui ne vous correspond
              pas… vous allez vous sentir misérable toute votre vie. Votre volonté de réaliser les besoins de la société n’est
              RIEN comparée à la direction de votre naissance. Vos chances de succès dans une voie qui n’est pas la vôtre sont
              quasi nulles. Les anciens schémas continueront de se répéter, encore et encore. Heureusement, il est possible de
              trouver votre boussole intérieure, de trouver la voie qui vous correspond vraiment. Vous pouvez maintenant sortir de
              cette crise intérieure, puisqu’en connaissant votre bagage intérieur…
            </p>
          </b-col>
        </b-row>
        <b-row class="py-5">
          <b-col cols="4">
            <img width="200px" src="@/assets/numerology/icon_compass.png" alt="compass" />
            <p>Vous saurez quelle direction prendre pour entamer cette nouvelle partie de votre vie.…</p>
          </b-col>
          <b-col cols="4">
            <img width="200px" src="@/assets/numerology/icon_graph_stock.png" alt="graph_stock" />
            <p>
              Vous saurez quelle direction vous permettra d’exprimer TOUT votre potentiel professionnel et réaliser votre
              carrière...
            </p>
          </b-col>
          <b-col cols="4">
            <img width="200px" src="@/assets/numerology/icon_heart.png" alt="heart" />
            <p>Vous saurez quelle direction vous permettra de trouver le bonheur personnel, relationnel avec votre partenaire…</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p>
              Il y a encore tellement de choses à explorer dans votre étude Numérologique… Tellement de nombres à décoder pour
              comprendre avec précision votre boussole intérieure. Par exemple, nous pourrions affiner l’interprétation de votre
              nombre de la destinée en prenant en compte les nuances de l’Élan spirituel et de la Pierre Angulaire. Comme vous
              pouvez l’imaginer, mes ressources sont limitées. Je dois réguler les informations que je vous donne sans savoir si
              vous êtes prêt à aller plus loin ou non. Jusqu’à maintenant, je vous ai simplement donné un bref récapitulatif. Mais
              si vous le voulez, j’aimerais faire votre étude numérologique complète où je rentre dans les détails de votre bagage
              vibratoire… jusqu’à révéler toutes les facettes de votre personnalité. C’est comme si j’étais directement avec vous,
              dans une salle, pour une lecture complète. Lorsque vous aurez pris connaissance de votre étude Numérologique
              complète, vous allez constamment pouvoir vivre dans votre vibration.Vous saurez précisément pourquoi vous avez
              l’impression de vivre un décalage dans votre vie… et comment régler ce décalage pour trouver le bonheur et le
              succès.
            </p>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3"></b-col>
    </b-row>
    <b-row class="buy-block" :style="{ backgroundImage: `url(${backgroundImageUrl_5})` }">
      <b-col cols="3"></b-col>
      <b-col cols="6" class="text-center">
        <h2>L’opportunité est retirée dans :</h2>
        <div class="countdown">
          <span>{{ timeRemaining.days }} days</span>
          <span>{{ timeRemaining.hours }} hours</span>
        </div>
        <div class="numerology-cover" :style="{ backgroundImage: `url(${coverImageUrl})` }">
          <h3>Étude Numérologique</h3>
          <h3>{{ name }}</h3>
          <h4>{{ day }} {{ month }} {{ year }}</h4>
        </div>
        <router-link
          :to="{
            name: 'numerology-payment',
            params: {
              amount: amount,
              firstName: firstName,
              lastName: lastName,
              birthday: `${year}-${month}-${day}`,
            },
          }"
          class="buy-button my-5"
        >
          Commander Maintenant
        </router-link>
        <br />
        <img class="my-5" width="200px" src="@/assets/numerology/credit_cards.png" alt="secure_payment" />
      </b-col>
      <b-col cols="3"></b-col>
    </b-row>
    <b-row class="footer">
      <b-col class="text-center py-5">
        <p class="text-center" style="color: white">
          © 2024 Académie A.I.M.E® - Métamorphose personnelle et Spiritualité Appliquée
        </p>
        <p>
          <a href="https://academieaime.com/legal/" target="_blank">Mentions légales</a> |
          <a href="https://academieaime.com/confidentialite/" target="_blank">Politique de confidentialité</a> |
          <a href="https://academieaime.com/contact/" target="_blank">Contact</a>
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { GET_AUTH_TEMPORARY } from "@/store/actions";

import {
  BContainer,
  BRow,
  BCol,
  BModal,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
  BFormInput,
  ModalPlugin,
  BButton,
} from "bootstrap-vue";
Vue.use(ModalPlugin);

export default {
  name: "Numerologie",
  components: {
    BContainer,
    BRow,
    BCol,
    BModal,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    BFormDatepicker,
    BButton,
  },
  computed: {
    ...mapGetters("auth", ["currentUser", "isAuthenticated"]),
    words() {
      return this.name.toUpperCase().split(" ");
    },
    dayDigits() {
      return this.day.toString().split("").join("+");
    },
    dayNumber() {
      const dayDigits = this.dayDigits.split("+");
      let total = dayDigits.reduce((sum, digit) => sum + parseInt(digit), 0);

      while (total > 9) {
        total = total
          .toString()
          .split("")
          .reduce((sum, digit) => sum + parseInt(digit), 0);
      }

      return total;
    },
    monthDigits() {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      if (!isNaN(this.month)) return this.month.toString().split("").join("+");
      else return (months.indexOf(this.month) + 1).toString().split("").join("+");
    },
    monthNumber() {
      const monthDigits = this.monthDigits.split("+");
      let total = monthDigits.reduce((sum, digit) => sum + parseInt(digit), 0);

      while (total > 9) {
        total = total
          .toString()
          .split("")
          .reduce((sum, digit) => sum + parseInt(digit), 0);
      }

      return total;
    },
    yearDigits() {
      return this.year.toString().split("").join("+");
    },
    yearNumber() {
      const yearDigits = this.yearDigits.split("+");
      let total = yearDigits.reduce((sum, digit) => sum + parseInt(digit), 0);

      while (total > 9) {
        total = total
          .toString()
          .split("")
          .reduce((sum, digit) => sum + parseInt(digit), 0);
      }

      return total;
    },
    lifePathNumber() {
      let total = this.dayNumber + this.monthNumber + this.yearNumber;

      while (total > 9) {
        total = total
          .toString()
          .split("")
          .reduce((sum, digit) => sum + parseInt(digit), 0);
      }

      return total;
    },
    timeRemaining() {
      const now = new Date();
      const distance = this.targetDate - now;

      if (distance < 0) {
        clearInterval(this.timer);
        return {
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
        };
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      return {
        days,
        hours,
        minutes,
        seconds,
      };
    },
    amount() {
      const { days, hours, minutes, seconds } = this.timeRemaining;
      if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) return "full";
      return "discount";
    },
  },
  data() {
    return {
      name: "",
      firstName: "",
      lastName: "",
      gender: "male",
      day: 1,
      month: "January",
      year: 2024,
      tempBirthdate: null,
      targetDate: new Date(),
      timer: null,
      backgroundImageUrl_1: require("@/assets/numerology/background_01.png"),
      backgroundImageUrl_2: require("@/assets/numerology/background_02.png"),
      backgroundImageUrl_3: require("@/assets/numerology/background_03.png"),
      backgroundImageUrl_4: require("@/assets/numerology/background_04.png"),
      backgroundImageUrl_5: require("@/assets/numerology/background_05.png"),
      coverImageUrl: require("@/assets/numerology/numerology_cover.png"),
    };
  },
  async mounted() {
    const { isAuthenticated } = this;
    const { firstName, lastName = null, birthdate = null, gender = "male" } = this.currentUser || {};

    // TODO: If loggedIn && has birthdate
    if (isAuthenticated && birthdate && firstName) {
      const { day, month, year } = birthdate;
      this.day = day;
      this.month = month;
      this.year = year;

      this.name = lastName ? `${firstName} ${lastName}` : firstName;
      this.gender = gender;
    } else if (isAuthenticated && !birthdate) {
      this.$bvModal.show("birthdate-modal");
    } else {
      this.$bvModal.show("birthdate-modal");
      //     this.$router.push({ name: "numerology-payment" });
    }

    const { email } = this.$route.query;
    if (email) {
      const result = await this.getAuthTemporary({ email });

      this.targetDate = new Date(result?.createdAt);
      this.targetDate.setDate(this.targetDate.getDate() + 3);
    } else {
      this.targetDate.setDate(this.targetDate.getDate() + 3);
    }

    this.timer = setInterval(() => {
      this.$forceUpdate();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    ...mapActions("auth", { getAuthTemporary: GET_AUTH_TEMPORARY }),
    getAlphabetNumber(letter) {
      if (letter === " ") return 0;
      return letter.charCodeAt(0) - "A".charCodeAt(0) + 1;
    },
    onSubmitBirthdate() {
      if (this.tempBirthdate) {
        const birthdate = this.tempBirthdate.split("-");
        this.day = birthdate[2];
        this.month = birthdate[1];
        this.year = birthdate[0];
        this.$bvModal.hide("birthdate-modal");
      }
    },
    updateName() {
      this.name = this.lastName ? `${this.firstName} ${this.lastName}` : this.firstName;
    },
    closeModal() {
      this.tempBirthdate = null;
      this.$bvModal.hide("birthdate-modal");
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto");

.countdown span {
  display: inline-block;
  color: #fff;
  margin: 0 5px;
}

p {
  font-family: "Roboto", sans-serif;
  font-size: 1rem;
  font-weight: 300;
}

.white-bg {
  background: #fff;
}
.hero-block {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 5rem 0;
  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 2rem;
    font-weight: 300;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  h1 {
    font-family: "Roboto", sans-serif;
    font-size: 3rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-top: 0;
  }
}

.profile-block {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  img {
    max-width: 150px;
    height: auto;
    margin-right: 2rem;
  }
  .profile-info {
    h3 {
      font-family: "Roboto", sans-serif;
      font-size: 2rem;
      font-weight: 700;
      color: #fff;
      text-transform: uppercase;
      margin-bottom: 0;
    }
    p {
      font-family: "Roboto", sans-serif;
      font-size: 1rem;
      font-weight: 300;
      color: #fff;
      text-transform: uppercase;
      margin-top: 0;
    }
  }
}

.intro-block {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: #000;
    text-transform: uppercase;
    margin-bottom: 0;
  }
}
.info-block {
  background: #fff;
  padding-bottom: 3rem;
  img {
    max-width: 264px;
    height: auto;
    float: right;
    padding-right: 2rem;
  }

  p {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    font-weight: 300;
    color: #000;
    text-align: justify;
    margin-top: 0;
    max-width: 500px;
  }
}

.calc-block {
  padding: 2rem 0;
  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  .lifepath-calculation-table {
    margin: 2rem auto;
    table-layout: fixed;
    text-align: left;
  }

  .lifepath-block {
    box-shadow: inset 0px 18px 30.1px 4.9px rgba(0, 0, 0, 0.21);
    background: rgb(57, 92, 131);
    color: #ffffff;
    font-family: "Roboto", sans-serif;
    font-size: 18px;
    padding: 9px;
    min-width: 85px;
    text-align: center;
    border-radius: 25px;
    overflow: hidden;
  }

  td[class^="lifepath-column-"] {
    text-align: center;
  }

  .lifepath-column-1,
  .lifepath-column-3,
  .lifepath-column-5 {
    min-width: 120px;
  }

  .lifepath-column-7 {
    min-width: 110px;
  }

  .lifepath-column-2,
  .lifepath-column-4,
  .lifepath-column-6 {
    width: 40px;
  }

  .lifepath-block .digit,
  .lifepath-block .plus {
    display: inline-block;
    opacity: 1;
  }

  .lifepath-calculation-table tr td.empty-cell {
    color: #f5f6f7;
    font-size: 43px;
    font-weight: 700;
    text-align: center;
    padding: 5px;
    line-height: 20px;
  }

  .lifepath-calculation-table tr td.empty-cell div {
    opacity: 1;
  }

  .lifepath-arrow {
    width: 25px;
    height: 18px;
    background: url(https://academieaime.com/numerologie-images/lifepath-arrow.png) no-repeat;
    margin: 0 5px;
    opacity: 1;
    display: inline-block;
  }

  .lifepath-result {
    background: #9e52ce;
    color: #fff;
    font-size: 48px;
    font-weight: 500;
    font-family: "Roboto";
    padding: 25px;
    line-height: 48px;
  }
}

.number-reveal-block {
  padding: 2rem 0;
  align-items: center;
  justify-content: center;
  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  h3 {
    font-family: "Roboto", sans-serif;
    font-size: 100px;
    font-weight: 700;
    color: #e7b0fe;
    text-transform: uppercase;
    margin-bottom: 0;
  }
}

.number-description-block {
  padding: 2rem 0;
  align-items: center;
  justify-content: center;
  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  p {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    font-weight: 300;
    color: #fff;
    text-align: justify;
    margin-top: 0;
    max-width: 500px;
  }
  img {
    max-width: 264px;
    height: auto;
    padding-right: 2rem;
  }
}

.name-calc-block {
  padding: 2rem 0;
  align-items: center;
  justify-content: center;
  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  p {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    font-weight: 300;
    color: #fff;
    text-align: justify;
    margin-top: 0;
  }
  ul {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    font-weight: 300;
    color: #fff;
    text-align: justify;
    margin-top: 2rem;
  }
  .intro-block {
    background: transparent;
  }

  .name-numerology {
    text-align: center;
    padding: 20px;
  }

  .letter-container {
    display: inline-block;
    margin: 0 10px;
  }

  .number {
    display: block;
    color: #fff;
    margin-bottom: 5px;
    font-size: 1.2em;
  }

  .letter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 80px;
    border: 3px solid #fff;
    border-radius: 10px;
    color: #fff;
    font-size: 2em;
    font-family: "Roboto", sans-serif;
    margin: 0 auto;
  }
}

.empty-row {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 5rem 0;
}

.buy-block {
  padding: 2rem 0;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  h2 {
    font-family: "Roboto", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0;
  }
  .countdown {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-family: "Roboto", sans-serif;
      font-size: 2rem;
      font-weight: 700;
      color: #fff;
      text-transform: uppercase;
      margin-bottom: 0;
      margin: 0 10px;
    }
  }
  a {
    font-family: "Roboto", sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    margin-bottom: 0;
    margin: 0 10px;
    padding: 10px 20px;
    background: rgb(0, 135, 25);
    border-radius: 10px;
    text-decoration: none;
  }
}
.numerology-cover {
  position: relative;
  text-align: center;
  color: white;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 375px;
  width: 100%;
  height: 500px;
  padding-top: 25px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.numerology-cover h2,
.numerology-cover h3,
.numerology-cover h4 {
  padding: 0.5em 1em;
  width: fit-content;
}
.btn-left {
  float: left;
}
.btn-right {
  float: right;
}

#date-input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
</style>
